import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';
import { Tree } from 'ng2-tree';

import { Planogram, LocationHierarchy, DeviceGroup, Device, ScheduledDevice } from '../models';
import { HttpService } from '../../../../../services/http.service';
import { Constants } from '../../../../../app.constant';

@Injectable()
export class PlanogramService extends HttpService {
  // public editdata: Planogram;
  private _ed: Planogram;
  public planogramId: any;
  public selectedCampaignForPreview: any;
  // public isApprovalList: boolean = false;
  public isApproverLevelObj = [];
  set editdata(val) {
    if (val && val.aspectRatioId == null && val.aspectRatio.aspectRatioId != null) {
      val.aspectRatioId = val.aspectRatio.aspectRatioId;
    }
    this._ed = val;
  }

  get editdata() {
    return this._ed;
  }

  getPlanograms(): Observable<any> {
    let param = { 'sort-by-priority': 'asc' };
    let requestOptionsArgs = { search: param };
    return this.getApi('/planogram', requestOptionsArgs, 'planogram-list')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getPendingPlanograms(): Observable<any> {
    let param = { 'sort-by-priority': 'asc' };
    let requestOptionsArgs = { search: param };
    return this.getApi('/planogram/waiting-for-approval', requestOptionsArgs, 'planogram-list')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  resetEditPlanogram() {
    this.editdata = null;
  }

  // Add and edit of planogram will happen in single api.
  savePlanogram(_temp: Planogram): Observable<any> {
    let planogram = _.cloneDeep(_temp)
    let saveAPI: any;
    let requestOptionsArgs = { body: planogram };

    if (planogram.planogramId) {    // edit
      saveAPI = this.putApi('/planogram/schedule/' + planogram.planogramId, requestOptionsArgs, 'planogram-edit');
    }
    else {                      // add
      saveAPI = this.postApi('/planogram/schedule', requestOptionsArgs, 'planogram-add');
    }
    return saveAPI
      .map(res => {
        let result = {};
        if (res.json()) {
          result = (planogram.planogramId) ? { planogramId: planogram.planogramId } : res.json().result;
        }
        return _.assignIn({}, result);
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // Add and edit of planogram-schedule will happen in single api.
  savePlanogramSchedule(_temp: Planogram): Observable<any> {
    let planogram = _.cloneDeep(_temp);
    let updateFields: Array<string> = ['planogramId', 'isPriorityPlanogram', 'recurrence', 'startDate', 'endDate', 'startTime', 'endTime'];
    _.pick(planogram, updateFields);
    console.log('CALL > savePlanogramSchedule() > planogram >', planogram);
    let saveAPI: any;
    let requestOptionsArgs = { body: planogram };

    if (planogram.planogramId) {    // edit
      saveAPI = this.putApi('/planogram/schedule/' + planogram.planogramId, requestOptionsArgs, 'planogram-edit');
    }
    else {                      // add
      saveAPI = this.postApi('/planogram/schedule', requestOptionsArgs, 'planogram-add');
    }
    return saveAPI
      .map(res => {
        let result = {};
        if (res.json()) {
          result = (planogram.planogramId) ? { planogramId: planogram.planogramId } : res.json().result;
        }
        return _.assignIn({}, result);
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // Get planogram-schedule by planogramId.
  getPlanogramSchedule(_planogramId: number): Observable<Planogram> {
    let requestOptionsArgs = {};
    return this.getApi('/planogram/schedule/' + _planogramId, requestOptionsArgs, 'planogram-schedule-one')
      .map(res => {
        let result: Planogram;
        if (res.json() && res.json().result) {
          result = <Planogram>res.json().result;
        }
        return result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  deletePlanogram(params: any = []): Observable<any> {
    let requestOptionsArgs = { body: { ids: params } };
    return this.deleteApi('/planogram', requestOptionsArgs, 'remove-planogram')
      .map(res => {
        this.response = res.json() && res.json().result;
        return this.response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // FOR PLANOGRAM DEVICE.
  getLocationHierarchyForPlanogramDevice(): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/location-hierarchy/user-access', requestOptionsArgs, 'location-hierarchy')
      .map(res => {
        let _locObj = <LocationHierarchy>res.json() && res.json().result;
        return _locObj;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // FOR PLANOGRAM DEVICE.
  getDeviceGroupForPlanogramDevice(params: any = {}): Observable<any> {
    let requestOptionsArgs = { search: params };
    return this.getApi('/deviceGroup/planogram', requestOptionsArgs, 'planogram-device-group')
      .map(res => {
        let _dgObj = <DeviceGroup>res.json() && res.json().result;
        return _dgObj;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // FOR PLANOGRAM DEVICE.
  getDeviceForPlanogramDevice(params: any = {}): Observable<any> {
    let requestOptionsArgs = { search: params };
    return this.getApi('/device/planogram', requestOptionsArgs, 'planogram-device')
      .map(res => {
        let _dgObj = <Device>res.json() && res.json().result;
        return _dgObj;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // FOR PLANOGRAM DEVICE.
  getPlanogramScheduledDevice(_param: number): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/planogram/device-logic/' + _param, requestOptionsArgs, 'planogram-scheduled-device')
      .map(res => {
        let _psdObj = res.json() && res.json().result;
        if (_psdObj.deviceLogic) {
          return <ScheduledDevice>_psdObj.deviceLogic;
        } else {
          return <ScheduledDevice>_psdObj;
        }
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  savePlanogramCampaign(planogramId: number, planogramEvents: any): Observable<any> {
    let requestOptionsArgs = new RequestOptions({ body: { 'layoutAndLayoutStrings': planogramEvents } });
    return this.putApi('/planogram/layout-and-layout-strings/' + planogramId, requestOptionsArgs, 'planogram-campaign')
      .map(res => {
        this.response = res.json() && res.json().result;
        return this.response
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getCampaignsByPlanogramId(planogramId: number): Observable<any> {
    let requestOptionsArgs = {}
    return this.getApi('/planogram/layout-and-layout-strings/' + planogramId, requestOptionsArgs, 'planogram-campaign')
      .map(res => {
        this.response = res.json() && res.json().result;
        return this.response
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }


  getPlanogramById(planogramId: number): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/planogram/' + planogramId, requestOptionsArgs, 'planogram-object')
      .map(res => {
        return res.json() && res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  savePlanogramList(list: Array<Planogram>, planogramId: number) {
    let requestOptionsArgs = new RequestOptions({ body: { 'planogramPriorities': list } });
    return this.putApi('/planogram/priorities', requestOptionsArgs, 'planogram-list')
      .mergeMap(res => {
        const response = res.json();
        return this.postApi(`/planogram/${planogramId}/submit`, {}, 'template-save');
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  savePlanogramListAsDraft(list: Array<Planogram>) {
    let requestOptionsArgs = new RequestOptions({ body: { 'planogramPriorities': list } });
    return this.putApi('/planogram/priorities', requestOptionsArgs, 'planogram-list')
      .map(res => {
        this.response = res.json();
        return this.response
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  // FOR PLANOGRAM DEVICE.
  inputPlanogramScheduleDevices(body: any = [], params: any = {}): any {
    let requestOptionsArgs = new RequestOptions({ body: { deviceLogic: body } });
    console.log("Body: ", requestOptionsArgs);
    return this.putApi('/planogram/device-logic/' + params.planogramId + '/' + params.deviceLogicId, requestOptionsArgs, 'planogram-device-logic')
      .map(res => {
        this.response = res.json();
        return this.response
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }


  getPlanogramsByAdvanceSearch(searchParam: any): Observable<any> {
    const optionals = Constants.setParamsObject(searchParam);
    let searchQuery: any;
    let query = optionals.split('=')
    if (query[1] != '%7B%7D') {
      searchQuery = optionals;
    } else {
      searchQuery = '';
    }
    let requestOptionsArgs = {};
    return this.getApi('/planogram' + searchQuery, requestOptionsArgs, 'planogram-list')
      .map(res => {
        return res.json() && res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  deleteDeviceLogic(params: any, deviceLogicId: number, planogramId: number): Observable<boolean> {
    let requestOptionsArgs = { body: { 'deviceLogic': params } };
    return this.deleteApi('/planogram/device-logic/' + planogramId + '/' + deviceLogicId, requestOptionsArgs, 'planogram-list')
      .map(res => {
        return res.json() && res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getCampaignForPlanogram(params: any = {}) {
    let requestOptionsArgs = { params: params };
    return this.getApi('/layout/search', requestOptionsArgs, 'planogram-campaign')
      .map(res => {
        return res.json() && res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  approvePlanogram(planogramId: Number): Observable<boolean> {
    let requestOptionsArgs = {};
    return this.postApi(`/planogram/${planogramId}/approve`, requestOptionsArgs, 'approve-campaign')
      .map(res => {
        let response = res.json();
        return response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  rejectPlanogram(planogramId: Number, comment: any): Observable<boolean> {
    let requestOptionsArgs = { body: comment };
    return this.postApi(`/planogram/${planogramId}/reject`, requestOptionsArgs, 'approve-campaign')
      .map(res => {
        let response = res.json();
        return response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getCampaignString(layoutStringId: number): Observable<any> {
    let requestOptionsArgs = {};
    return this.getApi('/layoutString/' + layoutStringId, requestOptionsArgs, 'campaign-string-list')
      .map(res => {
        return res.json() && res.json();
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  resetResponseCode() {
    this.isApproverLevelObj = [];
  }

  stopPlanogram(planogramId: number): Observable<any> {
    let requestOptionsArgs = new RequestOptions({ body: { 'planogramId': planogramId } });
    return this.putApi('/planogram/stop', requestOptionsArgs, 'planogram-stop')
      .map(res => {
        this.response = res.json() && res.json();
        return this.response
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  clonePlanogram(planogramId): Observable<any> {
    //campaign = _.assignIn({}, campaign);

    let requestOptionsArgs = {};
    return this.postApi('/planogram/clone/' + planogramId, requestOptionsArgs, 'clone-planogram')
      .map(res => {
        return res.json() && res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getDefaultCampaigns(params: any = {}) {
    let requestOptionsArgs = { params: params };
    return this.getApi('/default-layout', requestOptionsArgs, 'planogram-campaign')
      .map(res => {
        return res.json() && res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getDefaultCampaignDevices(layoutId: any = {}) {
    // let requestOptionsArgs = { params: params };
    return this.getApi(`/default-layout/devices/${layoutId}`, {}, 'planogram-campaign')
      .map(res => {
        return res.json() && res.json().result;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  setDefaultLayout(params: any): Observable<boolean> {
    // let requestOptionsArgs = params;
    let requestOptionsArgs = new RequestOptions({ body: params });
    return this.postApi(`/default-layout`, requestOptionsArgs, 'approve-campaign')
      .map(res => {
        let response = res.json();
        return response;
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/cms/components/planogram/services/planogram.service.ts